import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { ListHeader, RadioList, ShadowBox } from '../components';

const listWrapperBaseStyles = ({ theme }) => css`
  background: ${theme.colors.white};
  padding: 0 ${theme.spacings.byte};
`;

const ListWrapper = styled('div')(listWrapperBaseStyles);

const QuizAnswer = ({ title, items, selected, onSelect }) => (
  <ShadowBox>
    <ListHeader text={title} />
    <ListWrapper>
      <RadioList
        items={items}
        selected={selected}
        onSelect={onSelect}
        titleProps={{
          bold: true,
        }}
        centered
        sideIndent
      />
    </ListWrapper>
  </ShadowBox>
);

QuizAnswer.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
};

QuizAnswer.defaultProps = {
  items: [
    {
      id: 'stq-1',
      title: 1,
    },
    {
      id: 'stq-2',
      title: 3,
    },
    {
      id: 'stq-3',
      title: 2,
    },
    {
      id: 'stq-4',
      title: 5,
    },
  ],
};

export default QuizAnswer;
